import React from "react";
import PropTypes from "prop-types";

import LocalNewsService from "services/LocalNewsService";

class LocalNewsDropdown extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      locations: LocalNewsService.getLocations(),
    };
  }

  handleChangeLocation = (event) => {
    const { setLocation } = this.props;

    const id = event.target.value;
    const location = LocalNewsService.getLocations().find(
      (item) => item.id === id
    );

    setLocation(location);
    LocalNewsService.saveLocation(location);
  };

  render = () => {
    const { location, settings } = this.props;

    const { locations } = this.state;

    return (
      <div className="fake-select">
        <select onChange={this.handleChangeLocation} value={location.id}>
          {locations.map((option) => (
            <option value={option.id} key={option.id}>
              {option.text}
            </option>
          ))}
        </select>
        <span className="btn is-theme is-block">
          <span className="btn__text">{settings.dropdownText}</span>
        </span>
      </div>
    );
  };
}

LocalNewsDropdown.propTypes = {
  location: PropTypes.shape({}).isRequired,
  setLocation: PropTypes.func.isRequired,
  settings: PropTypes.object,
};

LocalNewsDropdown.defaultProps = {
  settings: {},
};

export default LocalNewsDropdown;
